import { Box, Button, List, ListItem } from '@mui/material'
import { clearAllBoxItems } from 'api/box'
import { clearOrders } from 'api/daily-order'
import DialogButton from 'components/DialogButton'
import Header from 'components/Header'
import ListNavigation from 'components/ListNavigation'
import { manageDailyOrderOperations, SnackbarSeverity } from 'constant'
import { LoadingContext } from 'contexts/LoadingContextProvider'
import { SnackContext } from 'contexts/SnackContextProvider'
import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { isAdmin } from 'utils/userUtils'

const ManageDailyOrder = () => {
  const { company } = useParams()
  const { handleOpenSnackbar } = useContext(SnackContext)
  const { setLoading } = useContext(LoadingContext)

  const handleClearOrders = async (setOpenPopup: (item: boolean) => void) => {
    setLoading(true)
    try {
      const result = await clearOrders(`${company}`)
      if (result.data.success) {
        handleOpenSnackbar(
          SnackbarSeverity.Success,
          'All daily orders cleared successfully'
        )
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.errorMessage || 'Unexpected error occurred'
      handleOpenSnackbar(SnackbarSeverity.Error, errorMessage)
    } finally {
      setLoading(false)
      setOpenPopup(false)
    }
  }

  const handleClearBoxItems = async (setOpenPopup: (item: boolean) => void) => {
    setLoading(true)
    try {
      const result = await clearAllBoxItems(`${company}`)
      if (result.data.success) {
        handleOpenSnackbar(
          SnackbarSeverity.Success,
          'All box items cleared successfully'
        )
      }
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.errorMessage || 'Unexpected error occurred'
      handleOpenSnackbar(SnackbarSeverity.Error, errorMessage)
    } finally {
      setLoading(false)
      setOpenPopup(false)
    }
  }

  return (
    <Box>
      <Header />
      <ListNavigation
        elements={manageDailyOrderOperations}
        company={company!}
      />
      <>
        <DialogButton
          buttonContent='Delete All Daily Orders'
          dialogTitle='Are you sure you want to delete all daily orders? This action cannot be undone.'
          handleConfirm={handleClearOrders}
        />
        <DialogButton
          buttonContent='Clear All Box Items'
          dialogTitle='Are you sure you want to clear all box items?'
          handleConfirm={handleClearBoxItems}
        />
      </>
    </Box>
  )
}

export default ManageDailyOrder
